import React from 'react';

import { DropdownArrowIcon } from '../Dropdown';
import { MdArrowDropDown } from 'react-icons/md';

export const DropdownIndicator = (props: any) => {
  return (
    <DropdownArrowIcon menuIsOpen={props.selectProps.menuIsOpen}>
      <MdArrowDropDown size={18} opacity={0.5} />
    </DropdownArrowIcon>
  );
};
